export class ControlLinkDTO {
  linkId: number;

  controlId: number;

  pinned: boolean;

  linkURLFragment?: string;

  constructor() {
    this.linkId = -1;
    this.controlId = -1;
    this.pinned = false;
  }
}
